module.exports = __webpack_public_path__ + "img/optimism.44ec7b35.svg";